export default __webpack_public_path__ + "static/media/cancel-btn.95230f29.svg";